import { useQuery } from "@tanstack/react-query";
import { fetchAgencyClients } from "../api/agencyClientApi";

export const AGENCY_CLIENTS_QUERY_KEY = ["agency", "clients"] as const;

export function useAgencyClientsQuery(enabled = true) {
  return useQuery({
    queryKey: AGENCY_CLIENTS_QUERY_KEY,
    queryFn: fetchAgencyClients,
    enabled,
    staleTime: 2 * 60 * 1000,
    retry: 1,
  });
}
